import { DEFAULT_ENABLED_GENERAL_REPORT_FIELD, GeneralReportEnabledField } from "domain/entity/GeneralReport/GeneralReportEnabledField";
import { EMPTY_GENERAL_REPORT_ENTITY, GeneralReportEntity } from "domain/entity/GeneralReport/GeneralReportEntity";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface GeneralReportDropdownOptions {
    reportTypeDropdownOptions: DropdownProps[],
    printQueueDropdownOptions: DropdownProps[],
    fileLocationDropdownOptions: DropdownProps[],
    companyCodeDropdownOptions: DropdownProps[],
    allCompanyCodeDropdownOptions: DropdownProps[],    
    masterCompanyCodeDropdownOptions: DropdownProps[],
    ccCompanyCodeDropdownOptions: DropdownProps[],
    slCompanyCodeDropdownOptions: DropdownProps[],
    chargeTypeDropdownOptions: DropdownProps[],
    tariffTypeDropdownOptions: DropdownProps[],
    tariffNatureDropdownOptions: DropdownProps[],
    customerCodeDropdownOptions: DropdownProps[],
    /*proposalNoFromDropdownOptions: DropdownProps[],
    proposalNoToDropdownOptions: DropdownProps[],*/
    proposalNoDropdownOptions: { [key: string]: DropdownProps[] },
    criteriaTypeDropdownOptions: DropdownProps[],
    criteriaNameDropdownOptions: DropdownProps[],
    typeDropdownOptions: DropdownProps[],
    thcDropdownOptions: DropdownProps[],
    shipmentTypeDropdownOptions: DropdownProps[],
    containerSizeDropdownOptions: DropdownProps[],
    containerStatusDropdownOptions: DropdownProps[],
    opsLineDropdownOptions: DropdownProps[],
    opsLineCompanyDropdownOptions: DropdownProps[],
    exceptionTypeDropdownOptions: DropdownProps[],
    transactionTypeDropdownOptions: DropdownProps[],
    subTypeDropdownOptions: DropdownProps[],
    operatingTmlDropdownOptions: DropdownProps[],
    serviceCodeDropdownOptions: DropdownProps[],
    viewDropdownOptions: DropdownProps[],
    companyNameDropdownOptions: DropdownProps[],
    //AQCT/OICT/RSCT
    companyTypeDropdownOptions: DropdownProps[],
    cashierDropdownOptions: DropdownProps[],
    typeSpecicalDropdownOptions: DropdownProps[],
    companyTypeSpecicalDropdownOptions: DropdownProps[],
    typeSpecial2DropdownOptions: DropdownProps[],
    shippingLineDropdownOptions: DropdownProps[],
    tariffCodeDropdownOptions: DropdownProps[],
}
export interface GeneralReportViewChangeState extends BaseViewChangeSate {
}

export interface GeneralReportModel {
    isLoading: boolean,
    reportIdList: string[],
    reportTypeList: string[],
    printQueueIdMap: { [key: string]: number },
    reportIdTypeMap: { [key: string]: string },
    criteriaTypeIdMap: { [key: string]: string },
    dynamicOptions: GeneralReportDropdownOptions,
    currentReport: GeneralReportEntity,
    enabledField: GeneralReportEnabledField,    
}

export const EMPTY_GENERAL_REPORT_MODEL: GeneralReportModel = {
    isLoading: false,
    dynamicOptions: {
        reportTypeDropdownOptions: [],
        printQueueDropdownOptions: [],
        fileLocationDropdownOptions: [],
        companyCodeDropdownOptions: [],
        allCompanyCodeDropdownOptions: [],
        chargeTypeDropdownOptions: [],
        tariffTypeDropdownOptions: [],
        tariffNatureDropdownOptions: [],
        customerCodeDropdownOptions: [],        
        masterCompanyCodeDropdownOptions: [],
        ccCompanyCodeDropdownOptions: [],
        slCompanyCodeDropdownOptions: [],
        criteriaTypeDropdownOptions: [],
        criteriaNameDropdownOptions: [],
        /*proposalNoFromDropdownOptions: [],
        proposalNoToDropdownOptions: [],*/
        proposalNoDropdownOptions: {},
        typeDropdownOptions: [],
        thcDropdownOptions: [],
        shipmentTypeDropdownOptions: [],
        containerSizeDropdownOptions: [],
        containerStatusDropdownOptions: [],
        opsLineDropdownOptions: [],
        opsLineCompanyDropdownOptions: [],
        exceptionTypeDropdownOptions: [],
        transactionTypeDropdownOptions: [],
        subTypeDropdownOptions: [],
        operatingTmlDropdownOptions: [],
        serviceCodeDropdownOptions: [],
        viewDropdownOptions: [],
        companyNameDropdownOptions: [],
        companyTypeDropdownOptions: [],
        cashierDropdownOptions: [],
        typeSpecicalDropdownOptions: [],
        companyTypeSpecicalDropdownOptions: [],
        typeSpecial2DropdownOptions: [],
        shippingLineDropdownOptions: [],
        tariffCodeDropdownOptions: [],        
    },
    printQueueIdMap: {},
    reportTypeList: [],
    currentReport: { ...EMPTY_GENERAL_REPORT_ENTITY },
    enabledField: { ...DEFAULT_ENABLED_GENERAL_REPORT_FIELD },
    reportIdTypeMap: {},
    reportIdList: [],
    criteriaTypeIdMap: {},   
}